import { render, staticRenderFns } from "./TokenCalculationsTable.vue?vue&type=template&id=0a031a6e&scoped=true"
import script from "./TokenCalculationsTable.vue?vue&type=script&lang=ts"
export * from "./TokenCalculationsTable.vue?vue&type=script&lang=ts"
import style0 from "./TokenCalculationsTable.vue?vue&type=style&index=0&id=0a031a6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a031a6e",
  null
  
)

export default component.exports